// extracted by mini-css-extract-plugin
module.exports = {"containerFullHeight":"Skeleton_containerFullHeight__3TAIU","containerItemsCenter":"Skeleton_containerItemsCenter__2Zbed"};